import { useEffect, useCallback } from 'react';
import { HandySvg } from 'handy-svg';
import iconCross from '../../assets/icons/svg-sprite/close-cross.svg';
import { cards } from '../../lib/api/api';
import closeBanner from '../../modules/close-banner';
import anchorScrolling from '../../modules/anchor-scrolling';

const AdditionalPackage = ({ID, data, changeMessage}) => {
    const {name, billing_service_code, date, price} = data;
    const period = {
        '30': 'мес',
        '90': '3мес',
        '180': '6мес',
        '365': 'год'
    }

    useEffect(() => {
        closeBanner();
        anchorScrolling();
    }, []);

    function changeOfDate(date) {
        return `${date.slice(8, 10)}.${date.slice(5, 7)}.${date.slice(0, 4)}`;
    }

    const deletePackage = useCallback(
        (ID, billing_service_code) =>
            {
                const banner = document.getElementById('messageBanner');
                banner.style.removeProperty('display');
                cards.deleteSubscription(ID, billing_service_code)
                    .then(() => {
                        changeMessage('Заявка на изменение подписки успешно создана!');
                    })
                    .catch((err) => {
                        changeMessage('Ошибка отключения, попробуйте позже');
                        console.log(err);
                    });
            },
        []);

    return (
        <>
            <li className="info-cards__price-item">
                <div className="info-cards__price-list-heading-wrap">
                    <span className="info-cards__price-list-name">
                        <a className='js-anchor-link service-name-hidden' href="#all-services">{name}</a>
                    </span>
                    <span className="info-cards__price-list-description">
                        {date.start ? (date.unsubscribed ? `отключение ${changeOfDate(date.unsubscribed)}` : `до ${changeOfDate(date.end)}`) : 'ожидает оплаты'}
                    </span>
                </div>
                <div className="info-cards__price-list-info-wrap">
                    <span className="info-cards__price number number--dashboard">{Math.ceil(price.rubles)} <span className="number__units">Р/{period[price.days]}</span></span>
                    {date.unsubscribed ? '' : (
                        <button className="info-cards__delete-btn" type="button" onClick={() => deletePackage(ID, billing_service_code)}>
                            <HandySvg className="svg-icon" src={iconCross} width="12" height="12"/>
                            Отключить
                        </button>
                    )}
                </div>
            </li>
        </>
    );
};

export default AdditionalPackage;